"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("./app"));
(0, render_app_1.default)('data-oos-signup-app', function (el) {
    var datasetVariant = el.dataset.variant;
    if (!datasetVariant)
        throw new Error('Missing oos-signup data-variant');
    var variant = JSON.parse(datasetVariant);
    var className = el.dataset.className;
    var linkText = el.dataset.linkText;
    if (!linkText)
        throw new Error('Missing oos-signup data-link-text');
    return (react_1.default.createElement(app_1.default, { variant: variant, className: className },
        react_1.default.createElement("span", null, linkText)));
});
